import { useEffect, useMemo } from 'react';

import { requestWithAbort, useLazyService } from '../use-service';

interface LicenseCheckData {
	hostname: string;
}

export const useLicenseCheck = (cloudId: string) => {
	const [request, controller] = useMemo(
		() =>
			requestWithAbort(`/gateway/api/xflow/${cloudId}/license-information`, {
				method: 'GET',
			}),
		[cloudId],
	);

	const [getLicenseCheck, result] = useLazyService<LicenseCheckData>(request, controller);

	useEffect(() => {
		if (cloudId) {
			getLicenseCheck();
		}
	}, [cloudId, getLicenseCheck]);

	return result;
};
